<template>
  <div class="octobus__modal" :class="{ 'is-active' : show }">
    <div class="octobus__modal-background"></div>
    <div class="octobus__modal-card">
      <header class="octobus__modal-card-head">
        <p class="octobus__modal-card-title">{{ $t('auth.newpassword.title') }}</p>
        <button class="octobus__delete" aria-label="close" @click="onHideModal"></button>
      </header>
      <section class="octobus__modal-card-body">
        <p class="octobus__signin-error has-text-danger has-text-centered" v-if="error.name">{{error.name}}</p>
        <p class="octobus__signin-error" v-else>&nbsp;</p>
        <div class="octobus__columns">
          <div class="octobus__column">
            <div class="octobus__field">
              <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="newpassword__password">
                {{$t('auth.newpassword.password')}}
              </label>
              <p class="octobus__control has-icons-left has-icons-right">
                <input
                  :class="{
                    'is-danger': errors.has('newpassword__password'),
                    'is-primary': !errors.has('newpassword__password') && fields['newpassword__password'] && fields['newpassword__password'].dirty
                  }"
                  v-validate="'required|min:6'"
                  class="octobus__input is-medium"
                  type="password"
                  :placeholder="$t('auth.newpassword.password')"
                  id="newpassword__password"
                  name="newpassword__password"
                  v-model.trim="password"
                >
                <span class="octobus__icon is-small is-left">
                  <font-awesome-icon
                    :icon="passwordIcon"
                  />
                </span>
              </p>
              <p v-show="errors.has('newpassword__password')" class="octobus__help is-danger">{{ errors.first('newpassword__password') }}</p>
            </div>
          </div>
          <div class="octobus__column">
            <div class="octobus__field">
                <label class="octobus__label is-size-7-touch has-text-grey has-text-weight-light" for="newpassword__cpassword">
                    {{$t('auth.newpassword.cpassword')}}
                </label>
                <p class="octobus__control has-icons-left has-icons-right">
                    <input
                        :class="{
                            'is-danger': errors.has('newpassword__cpassword'),
                            'is-primary': !errors.has('newpassword__cpassword') && fields['newpassword__cpassword'] && fields['newpassword__cpassword'].dirty
                        }"
                        v-validate="'required|confirmed:newpassword__password|min:6'"
                        class="octobus__input is-medium"
                        type="password"
                        :placeholder="$t('auth.newpassword.cpassword')"
                        id="newpassword__cpassword"
                        name="newpassword__cpassword"
                        v-model.trim="cpassword"
                    >
                    <span class="octobus__icon is-small is-left">
                        <font-awesome-icon
                            :icon="passwordIcon"
                        />
                    </span>
                </p>
              <p v-show="errors.has('newpassword__cpassword')" class="octobus__help is-danger">{{ errors.first('newpassword__cpassword') }}</p>
            </div>
          </div>
        </div>
      </section>
      <footer class="octobus__modal-card-foot">
        <button class="octobus__button is-primary" :class="{'is-loading': loading}" @click="onSubmit">{{ $t('auth.newpassword.successBtn') }}</button>
        <button class="octobus__button" @click="onHideModal">{{ $t('auth.newpassword.cancelBtn') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faKey } from '@fortawesome/fontawesome-free-solid';
import api from '@/api';

export default {
  name: 'NewPassword',
  components: {
    FontAwesomeIcon,
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      password: '',
      cpassword: '',
      error: {},
      loading: false,
      id: null,
    };
  },
  methods: {
    onHideModal() {
      this.$emit('hideModal');
    },
    onClickRecovery() {
      this.$emit('show', 'recovery');
    },
    async onSubmit() {
      const validateSignin = await this.$validator.validateAll();

      if (validateSignin === true) {
        this.sendReset();
      }
    },
    errorReset(res) {
      const msg = ((res || {}).error).name;

      this.$toasted.show(msg);
    },
    successReset() {
      this.onHideModal();
      this.$toasted.show(this.$t('profile.success'));
    },
    async sendReset() {
      const { token, password } = this;

      this.loading = true;
      try {
        const response = await api.Authentication.resetPassword(token, password);

        if (response && response.error) {
          this.errorReset(response);
        } else {
          this.successReset();
        }
      } catch (e) {
        throw e;
      }

      this.loading = false;
    },
  },
  computed: {
    passwordIcon() {
      return faKey;
    },
  },
  mounted() {
    api.Authentication.recoveryCheck(this.token).then((res) => {
      if (res && res.error) {
        const { name } = res.error;
        this.$toasted.show(name);
        this.onHideModal();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/_common/NewPassword.vue